<div *ngIf="reportType === 'Rep unpaid Commission'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================= HEADER ================= -->
    <table style="width:100%; border-collapse:collapse; ">
     <tr style="font-size:16px; font-weight:bold;">
        <th colspan="1" style="border:none; text-align:center; padding:8px; border-bottom: 1px solid black;border-left: 1px solid black;border-top: 1px solid black;border-right:1px solid black;">
          हिंदुस्तान प्रकाशन संस्था 
        </th>
        <th colspan="1" style="border:none; text-align:center; padding:8px; border-bottom: 1px solid black;border-top: 1px solid black;border-right:1px solid black;">
          Book Commission Report
        </th>
        <th colspan="2" style="border:none; text-align:right; padding:8px; border-bottom: 1px solid black;border-top: 1px solid black;border-right : 1px solid black;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- Sub Header Row -->
      <tr style="font-size:16px; font-weight:bold;">
        <th colspan="1" style="border:none; text-align:center; padding:8px;border-left: 1px solid black;border-right:1px solid black;">
         विवेक पुस्तक प्रकाशन
        </th>
        <th colspan="1" style="border:none; text-align:center; padding:8px;border-right:1px solid black;">
          Rep unpaid Commission

        </th>
        <th colspan="2" style="border:none; text-align:right; padding:8px;border-right: 1px solid black;">
          From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= TABLE HEADER ================= -->
    <table style="width:100%; border-collapse: collapse; border:1px solid black;">
      <thead>
        <tr style="background:#f0f0f0; font-weight:bold; text-align:center;">
          <th style="border:1px solid black; padding:6px;">Invoice Date</th>
          <th style="border:1px solid black; padding:6px;">Invoice No</th>
          <th style="border:1px solid black; padding:6px;width:20%;">Book Seller Name</th>
          <th style="border:1px solid black; padding:6px;">Invoice Amount</th>
          <th style="border:1px solid black; padding:6px;">Invoice<br>Recived Amount</th>
          <th style="border:1px solid black; padding:6px;">Invoice<br>commission</th>
          <th style="border:1px solid black; padding:6px;">unpaid<br>commission</th>
        </tr>
      </thead>

      <tbody>

        <!-- GROUP: OFFICE LEVEL -->
        <ng-container *ngFor="let office of groupedData">

          <!-- Office Rep -->
          <tr style="background:#ffffff; font-weight:bold;">
            <td colspan="8" style="border:1px solid black; padding:8px; text-align:center; font-size:18px;">
              Office Representative - {{ office.office_rep_name }}
            </td>
          </tr>

          <!-- GROUP: REP LEVEL -->
          <ng-container *ngFor="let rep of office.repGroups">

            <tr>
              <td colspan="8" style="border:1px solid black; padding:6px; font-weight:bold;">
                Representative - {{ rep.rep_name }}
              </td>
            </tr>

            <!-- Rows -->
            <tr *ngFor="let row of rep.records">
              <td style="border:1px solid black; padding:6px;">{{ row.invoice_date | date:'dd-MM-yyyy' }}</td>
              <td style="border:1px solid black; padding:6px;">{{ row.invoice_no }}</td>
              <td style="border:1px solid black; padding:6px;">{{ row.receiver_name }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ row.invoice_total }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ row.invoice_received_amt }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ row.rep_commission_amt }}</td>

              <!-- UPDATED unpaid commission -->
              <td style="border:1px solid black; padding:6px; text-align:right;">
                {{ row.remaining_amt == 0 ? '' : row.remaining_amt }}
              </td>
            </tr>

            <!-- Representative Subtotal -->
            <tr style="font-weight:bold;">
              <td colspan="3" style="border:1px solid black; padding:6px; text-align:right;">
                Representative Total:
              </td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ rep.repTotal_invoice }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ rep.repTotal_received }}</td>
              <td style="border:1px solid black; padding:6px; text-align:right;">{{ rep.repTotal_commission }}</td>

              <!-- UPDATED subtotal unpaid -->
              <td style="border:1px solid black; padding:6px; text-align:right;">
                {{ rep.repTotal_unpaid == 0 ? '' : rep.repTotal_unpaid }}
              </td>
            </tr>

          </ng-container>

          <!-- OFFICE TOTAL -->
          <tr style="background:#f4b084; font-weight:bold;">
            <td colspan="3" style="border:1px solid black; padding:8px; text-align:right;">
              Office Total: {{ office.office_rep_name }}
            </td>
            <td style="border:1px solid black; padding:8px; text-align:right;">{{ office.total_invoice }}</td>
            <td style="border:1px solid black; padding:8px; text-align:right;">{{ office.total_received }}</td>
            <td style="border:1px solid black; padding:8px; text-align:right;">{{ office.total_commission }}</td>

            <!-- UPDATED office-level unpaid -->
            <td style="border:1px solid black; padding:8px; text-align:right;">
              {{ office.total_unpaid == 0 ? '' : office.total_unpaid }}
            </td>
          </tr>

        </ng-container>
          <tr style="background-color: #c8753f; font-weight:bold;">
          <td colspan="3" style="border:1px solid black; padding:8px; text-align:right;">
            GRAND TOTAL :
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">{{ grandTotal.total_invoice }}</td>
          <td style="border:1px solid black; padding:8px; text-align:right;">{{ grandTotal.total_received }}</td>
          <td style="border:1px solid black; padding:8px; text-align:right;">{{ grandTotal.total_commission }}</td>
          <!-- <td style="border:1px solid black; padding:8px; text-align:right;">{{ grandTotal.total_paid }}</td> -->
          <td style="border:1px solid black; padding:8px; text-align:right;">{{ grandTotal.total_unpaid }}</td>
        </tr>

      </tbody>
    </table>

    <div class="noPrint d-flex justify-content-end gap-3 px-4 mt-3 mb-4">
      <button class="btn btn-primary" (click)="exportExcel('RepCommissionReport')">Export</button>
      <button class="btn btn-primary" (click)="printPageA4() ">Print</button>
      <button class="btn btn-secondary" mat-dialog-close>Close</button>
    </div>

  </div>
</div>
